import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import FinanceSidebar from "./FinanceSidebar";
import "./FinanceLayout.css";

const Finance = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // On phones the menu closes by itself after you open a page.
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <div
      className="finance-shell"
      style={{
        display: "flex",
        width: "100%",
        height: "calc(100vh - 48px)",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      {/* Phone / tablet only: tap to show or hide the Finance menu */}
      <button
        type="button"
        className="finance-menu-toggle"
        onClick={() => setMenuOpen((open) => !open)}
        aria-expanded={menuOpen}
        aria-controls="finance-sidebar-wrap"
      >
        <span>☰ Finance Menu</span>
        <span className="finance-menu-toggle-arrow">
          {menuOpen ? "▲" : "▼"}
        </span>
      </button>

      <div
        id="finance-sidebar-wrap"
        className={`finance-sidebar-wrap${menuOpen ? " is-open" : ""}`}
      >
        <FinanceSidebar />
      </div>

      <div
        className="finance-content-scroll"
        style={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Finance;
